export default {
	title: "Assistente ORI",
	subtitle: "Tire suas dúvidas sobre o sistema",
	openLabel: "Abrir assistente",
	closeLabel: "Fechar",
	expandLabel: "Expandir",
	collapseLabel: "Recolher",
	clearLabel: "Limpar conversa",
	placeholder: "Escreva sua dúvida...",
	send: "Enviar",
	thinking: "Digitando...",
	emptyTitle: "Como posso ajudar?",
	emptyHint: "Pergunte sobre cadastros, rituais, financeiro e mais.",
	disclaimer:
		"Respostas geradas por IA podem conter erros. Confira informações importantes.",
	clearConfirm: "Apagar toda a conversa?",
	errorGeneric: "Não consegui responder agora. Tente novamente.",
	errorUnavailable: "Assistente indisponível no momento.",
	suggestions: {
		s1: "Como cadastro uma pessoa?",
		s2: "Como faço a chamada de fichas?",
		s3: "Onde vejo o fechamento financeiro?",
	},
	guidedMode: {
		question: "Como você prefere configurar o terreiro?\n\n**Automático**: eu monto cada cadastro e você só confirma no card.\n**Manual**: eu te oriento pela tela e você faz, aprendendo o caminho.",
		automatic: "Automático",
		manual: "Manual",
	},
	quickReplies: {
		label: "Opções de resposta",
	},
	actions: {
		confirm: "Confirmar",
		edit: "Alterar",
		cancel: "Cancelar",
		created: "Criado com sucesso!",
		createError: "Não consegui criar. Tente novamente.",
		createErrorWithReason: "Não consegui criar: {reason}",
		checkOnScreen: "Este cadastro pode já ter sido criado. Confira na tela antes de pedir de novo.",
		noPermission: "Você não tem permissão para isso.",
		continue: "Continuar",
		continueMsg: "Pronto, criei esse. Vamos para o próximo.",
	},
};
